/* tslint:disable */
/* eslint-disable */
/* @relayHash 619644133601ae32e26827340be86ff1 */

import { ConcreteRequest } from "relay-runtime";
export type fetchUserMetadataQueryVariables = {
    email?: string | null;
};
export type fetchUserMetadataQueryResponse = {
    readonly viewer: {
        readonly disableCompleteAccountEmail: boolean | null;
        readonly userExistsMetadata: {
            readonly userExists: boolean | null;
            readonly emailOnly: boolean | null;
            readonly hasPassword: boolean | null;
        } | null;
    };
};
export type fetchUserMetadataQuery = {
    readonly response: fetchUserMetadataQueryResponse;
    readonly variables: fetchUserMetadataQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "email",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "disableCompleteAccountEmail",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableCompleteAccountEmail"
    }
  ],
  "storageKey": "isEnabled(key:\"disableCompleteAccountEmail\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userExists",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailOnly",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPassword",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "fetchUserMetadataQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userExistsMetadata",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "UserExistsMetadataType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "fetchUserMetadataQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userExistsMetadata",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "UserExistsMetadataType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "fetchUserMetadataQuery",
    "id": "ferrum/254.0.0-2020-03-02T14:38:36.831Z/fetchUserMetadataQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '6d867dae546608c43f089a097be1705d';
export default node;
